import keyBy from "lodash.keyby";
import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

const normalizeRoles = (roles = []) => {
  // Ensure roles is an array (defensive check)
  // Prevents .map() errors when data is malformed or during 404/500 prerender
  if (!Array.isArray(roles)) {
    return [];
  }
  return roles.map((role) => {
    return {
      id: role.id,
      ...role,
    };
  });
};

class RolesStore {
  roles = [];

  hasUserSeenVideo = false;

  constructor(initialData) {
    makeAutoObservable(this);
    // Ensure initialData.roles is an array before normalizing
    // Handle both empty initialData (404/500 pages) and malformed data
    if (initialData?.roles && Array.isArray(initialData.roles)) {
      this.roles.replace(normalizeRoles(initialData.roles));
    }
  }

  setHasUserSeenVideo = (state) => {
    this.hasUserSeenVideo = state;
  };

  get roleOptions() {
    return this.roles.map((role) => ({
      label: role.roleName,
      value: role.roleName,
    }));
  }

  get rolesByRoleName() {
    return keyBy(this.roles, "roleName");
  }
}

export default RolesStore;
